import httpService from "./httpService";
import utils from "./utils";

export default {
  getAllBook(example) {
    return this.findAll(example, null);
  },
  findAll(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(example, pageable);
    return httpService.get("/book", { params: params });
  },
  add(form) {
    return httpService.post("/book", form);
  },
  edit(id, form) {
    return httpService.put(`/book/${id}`, form);
  },
  delete(id) {
    return httpService.delete(`/book/${id}`);
  },
  findById(id, config) {
    return httpService.get(`/book/${id}`, config);
  },
  findAllBookDocTypeByDocId(id, config) {
    return httpService.get(`/book/findAllBookDocTypeByDocId/${id}`, config);
  },
  changeStatus(id, form) {
    return httpService.put(`/book/${id}/changeStatus`, form);
  }
};



// WEBPACK FOOTER //
// ./src/services/bookService.js